var radiored1 = {
   STOCKNOW:'?redirect=/products/edenpure-360-super-climater®-heater-cooler',//100224
   AD909:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-bogo',
   AP72:'?redirect=/products/edenpure®-whole-house-model-by-airfree®',//070224 
   BAF13A:'?redirect=/products/edenpure-360-air-fan-gen55-1',//022025
   BAF13B:'?redirect=/products/edenpure-360-air-fan-gen55-1',//022025
   BAF15:'?redirect=/products/edenpure-360-air-fan-gen55-1',//022025
   BAF16:'?redirect=/products/edenpure-360-air-fan-gen55-1',//031025
   BCV24:'?redirect=/products/edenpure-bio-speedclean-cordless-vac-model-vx200',//052423
   BCV26:'?redirect=/products/edenpure®-bio-speedclean™-cordless-vac-model-vx300',//110424
   BCV27:'?redirect=/products/edenpure®-bio-speedclean™-cordless-vac-model-vx300',//110424
   BCV28:'?redirect=/products/edenpure®-bio-speedclean™-cordless-vac-model-vx300',//121924
   BCV29:'?redirect=/products/edenpure®-bio-speedclean™-cordless-vac-model-vx300',//121924
   B2SCF13:'?redirect=/products/edenpure-bio-speedclean-cordless-vac-model-vx200',//032023
   B2SCF23:'?redirect=/products/edenpure-bio-speedclean-cordless-vac-model-vx200',//032023
   BSC2F13:'?redirect=/products/edenpure-bio-speedclean-cordless-vac-model-vx200',//032023
   BSC2F23:'?redirect=/products/edenpure-bio-speedclean-cordless-vac-model-vx200',//032023
   CLCHF33:'?redirect=/products/edenpure-classic-copperplus-1',//091823 
   CLCHF43:'?redirect=/products/edenpure-classic-copperplus-1',//091823 
   CLCHF14:'?redirect=/products/edenpure-classic-copperplus-1',//091823 
   DAF18:'?redirect=/products/edenpure®-360-infrared-heater-cooler',//072924 
   DAF19:'?redirect=/products/edenpure®-360-infrared-heater-cooler',//072924 
   EH587:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//073124
   EH590:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//073124
   EH590A:'?redirect=/pages/edenpure-copperplus-heater',//070224
   EH590B:'?redirect=/pages/edenpure-copperplus-heater',//070224
   EH591:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//073124
   EH592:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//073124
   EH593:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//073124
   EH594:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//072924
   EH595:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//072924
   EH596:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//072924
   EH597:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//072924
   EH598:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//072924
   EH599:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//072924
   EH600:'?redirect=/products/edenpure-classic-copperplus-1',//072924
   EH601:'?redirect=/products/edenpure-classic-copperplus-1',//072924
   EH602:'?redirect=/products/edenpure-classic-copperplus-1',//072924
   EH603:'?redirect=/products/edenpure®-gen40-plus-infrared-heater-1',//072924
   EH604:'?redirect=/products/edenpure®-gen40-plus-infrared-heater-1',//072924
   EH607:'?redirect=/products/edenpure-all-season-heater®-1',//073124
   EH608:'?redirect=/products/edenpure®-gen21-edenpure-all-season-heater®',//111224
   EH609:'?redirect=/products/edenpure®-gen21-edenpure-all-season-heater®',//111224
   EH610:'?redirect=/products/edenpure®-gen21-edenpure-all-season-heater®',//111224
   EH613:'?redirect=/products/edenpure®-gen2-infrared-heater-1',//111224
   EH614:'?redirect=/products/edenpure®-gen2-infrared-heater-1',//111224
   EH615:'?redirect=/products/edenpure®-gen2-infrared-heater-1',//111224
   EH617:'?redirect=/products/edenpure®-gen2-infrared-heater-1',//121924
   EH618:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//110424
   EH619:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//110424
   EH619A:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//110424
   EH619B:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//110424
   EH619C:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//110424
   EH620:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//110424
   EH621:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//110424
   EH622:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//110424
   EH623:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//110424
   EH624:'?redirect=/products/edenpure®-gen70-personal-heater-cooler-1',//110424
   EH625:'?redirect=/products/edenpure®-gen70-personal-heater-cooler-1',//110424
   EH626:'?redirect=/products/edenpure®-gen70-personal-heater-cooler-1',//110424
   EH628:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//111224
   EH629:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//111224
   EH630:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//112624
   EH631:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//112524
   EH632A:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//012025
   EH632B:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//012025
   EH632C:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//012025
   EH632D:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//012025
   EH633:'?redirect=/products/edenpure®-gen21-edenpure-all-season-heater®',//021225
   EH634:'?redirect=/products/edenpure®-gen21-edenpure-all-season-heater®',//021225
   EH635A:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//012025
   EH635B:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//012025
   EH636:'?redirect=/products/edenpure-classic-copperplus-1',//072924
   EH637:'?redirect=/products/edenpure-classic-copperplus-1',//072924
   EH638:'?redirect=/products/edenpure®-gen70-personal-heater-cooler-1',//021225
   EH639:'?redirect=/products/edenpure®-gen70-personal-heater-cooler-1',//021225
   EH640:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//112624
   EH641:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//021225
   EH642:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//021225
   EH643:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//021225
   EH644:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//021225
   EH645:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//021225
   EH646:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//021225
   EH647:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//021225
   EH648:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//021225
   EH649:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//021225
   EH650:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//021425
   EH652:'?redirect=/pages/eos',//040125
   EH653A:'?redirect=/products/edenpure®-gen21-edenpure-all-season-heater®',//041625
   EH653B:'?redirect=/products/edenpure®-gen21-edenpure-all-season-heater®',//041625
   EHB10:'?redirect=/products/edenpure®-gen40-infrared-heater-1',//112023
   EPSC20:'?redirect=/products/edenpure-360-super-climater®-heater-cooler',//111224
   EPSC21:'?redirect=/products/edenpure-360-super-climater®-heater-cooler',//111224
   EPSC22:'?redirect=/products/edenpure-360-super-climater®-heater-cooler',//121924
   F360F23:'?redirect=/products/edenpure-360-air-fan-heater-cooler',//031423 
   F360F33:'?redirect=/products/edenpure-360-air-fan-heater-cooler',//031423 
   GAP10A:'?redirect=/products/edenpure-g9-air-purifier-fa120',//072924
   GAP11:'?redirect=/products/edenpure-g9-air-purifier-fa120',//111224
   GAP12:'?redirect=/products/edenpure-g9-air-purifier-fa120',//111224
   GAP13:'?redirect=/products/edenpure-g9-air-purifier-fa120',//111224
   GAP14:'?redirect=/products/edenpure-g9-air-purifier-fa120',//111224
   GAP15:'?redirect=/products/edenpure-g9-air-purifier-x1-lite',//110424
   GAP16:'?redirect=/products/edenpure-g9-air-purifier-x1-lite',//021225
   HMD11:'?redirect=/products/edenpure®-mist-free-humidifier',//111224
   HMD12:'?redirect=/products/edenpure®-mist-free-humidifier',//111224
   HMD13:'?redirect=/products/edenpure®-mist-free-humidifier',//121924
   HMD14:'?redirect=/products/edenpure®-mist-free-humidifier',//121924
   HMD15:'?redirect=/products/edenpure®-mist-free-humidifier',//121924
   HMD16:'?redirect=/products/edenpure®-mist-free-humidifier',//121924
   SLVI:'?redirect=/products/edenpure-thunderstorm-oxileaf-iii-air-purifier-web-radio-offer',//021225
   TA713:'?redirect=/products/airdog-mist-free-room-humidifier',//011124
   TA733:'?redirect=/products/edenpure®-thunderstorm®-oxileaf®-iii-air-purifier-web-radio-offer',//061724
   TA736:'?redirect=/products/edenpure®-thunderstorm®-oxileaf®-iii-air-purifier-web-radio-offer',//061724
   TA761:'?redirect=/products/dr-schuft-formula',//021225
   THUNDER3:'?redirect=/products/edenpure-oxileaf-ii-thunderstorm-3-units',//110922 
   THUNDER20:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//ongoing 
   THUNDER21:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//ongoing 
   THUNDER22:'?redirect=/pages/edenpuredirect-com-oxileaf-ii-thunderstorm-air-purifier',//ongoing 
   TJW4H:'?redirect=/products/edenpure®-gen40-infrared-heater',//ongoing 
   TRP12:'?redirect=/products/edenpure-total-relief-heating-pad',//121924 
   TRP13:'?redirect=/products/edenpure-total-relief-heating-pad',//021225 
   TRP14:'?redirect=/products/edenpure-total-relief-heating-pad',//021225 
   TV1313:'?redirect=/pages/tv-oxileaf-iii-49-offer',//011025
   TV5656:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//100424
   TV6565:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-bogo',//040324
   TV5353:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-bogo',//040324
   TV4242:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-bogo',//040324
   TV4545:'?redirect=/pages/edenpure-copperplus-heater',//090624
   CP50:'?redirect=/pages/edenpure-copperplus-heater',//090624
   TV$50:'?redirect=/collections/heaters',//010225
   TVS50:'?redirect=/collections/heaters',//010225
   TV1212:'?redirect=/products/edenpure®-thunderstorm®-oxileaf®-iii-air-purifier-bogo',//091724
   TV8989:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-bogo',//040324
   TV2323:'?redirect=/collections/heaters',//100124
   TV2424:'?redirect=/collections/heaters',//040225
   TV2525:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//080624
   TV3838:'?redirect=/collections/air-purifiers',//080224
   TV6767:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',
   TV7878:'?redirect=/pages/edenpure®-gen70-heater',
   TV8989:'?redirect=/pages/edenpure®-gen70-heater',
   TV9090:'?redirect=/pages/tv-oxileaf-iii-49-offer',//011025
   TVBOGO:'?redirect=/pages/edenpure-oxileaf-air-purifier-bogo',//051424
   SPOT3:'?redirect=/products/edenpure-oxileaf-ii-thunderstorm-3-units',//ongoing 
   W0815:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-bogo',
   W0816:'?redirect=/pages/edenpure-household-cleaner-kit-w0702',
   W0817:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-bogo',
   W0818:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-bogo',
   W0819:'?redirect=/pages/edenpure-household-cleaner-kit-w0702',
   W0824:'?redirect=/pages/edenpure-all-season-heater-sales',
   W0825:'?redirect=/pages/airdog-car-air-purifier',
   W0829:'?redirect=/pages/edenpure®-gen40-plus-infrared-heater-eos',
   W0845:'?redirect=/pages/edenpure-oxileaf-air-purifier-bogo',//040424
   W0850:'?redirect=/pages/airdog-mold-free-humidifier',
   W0852:'?redirect=/pages/oxileaf-air-purifier-bogo',
   W0853:'?redirect=/pages/oxileaf-air-purifier-bogo',
   W0854:'?redirect=/pages/oxileaf-air-purifier-bogo',
   W0857:'?redirect=/pages/edenpure-airfree-3000-air-purifier-details',
   W0858:'?redirect=/pages/edenpure-all-season-heater-sale',
   W0863:'?redirect=/pages/blowout-refurbished-heater-sale',
   W0867:'?redirect=/products/edenpure®-gen70-personal-heater-cooler',
   W0868:'?redirect=/pages/airdog-car-air-purifier',
   W0869:'?redirect=/products/airdog-x3-home-air-purifier-215-sq-ft',
   W0870:'?redirect=/pages/edenpure-copperplus-heater-eos',
   W0873:'?redirect=/pages/edenpure-bio-speedclean-vx200-additional-24-savings',
   W0874:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-bogo',
   W0878:'?redirect=/pages/ep-360-air-fan-howie-carr-deal',
   W0879:'?redirect=/pages/airdog-portable-flexfan',
   W0882:'?redirect=/pages/edenpure-360-air-fan-heatercooler',
   W0890:'?redirect=/pages/edenpure-oxileaf-air-purifier-bogo',//082024
   W0900:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',
   W0903:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',
   W0904:'?redirect=/pages/edenpure-airfree-3000-air-purifier-details',
   W0905:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',
   W0907:'?redirect=/pages/edenpure-all-season-heater-sale',
   W0914:'?redirect=/pages/edenpure-gen30-elite-infrared-heater',
   W0915:'?redirect=/pages/edenpure-g9-air-purifier',
   W0917:'?redirect=/products/edenpure®-classic-copperplus™-infrared-heater',
   W0918:'?redirect=/products/edenpure®-gen21-edenpure-all-season-heater®',
   W0920:'?redirect=/pages/edenpure-bio-speedclean-vx200-additional-24-savings',
   W0921:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-bogo',
   W0922:'?redirect=/pages/edenpure®-gen40-hybrid-infrared-heater-email',
   W0923:'?redirect=/pages/edenpure®-360-air-fan-heater-cooler-extra-savings',
   W0936:'?redirect=/pages/edenpure-thunderstorm-l6844',
   W0938:'?redirect=/pages/edenpure-360-climater',
   W0939:'?redirect=/pages/edenpure-mist-free-humidifier',
   W0944:'?redirect=/pages/edenpure®-gen70-heater',
   W0945:'?redirect=/pages/edenpure-gen2-infrared-heater',
   W0950:'?redirect=/pages/edenpure-gen2-infrared-heater',
   W0951:'?redirect=/pages/edenpure-bio-speedclean-vx300',
   W0952:'?redirect=/products/edenpure-total-relief-heating-pad',
   W0953:'?redirect=/products/edenpure-total-relief-heating-pad',
   W0954:'?redirect=/products/edenpure®-thunderstorm®-oxileaf®-iii-air-purifier-bogo',//111924
   W0955:'?redirect=/pages/edenpure®-g9-air-purifier-one-day-sale',//112524
   W0956:'?redirect=/pages/edenpure®-gen40-hybrid-infrared-heater-email',//112524
   W0957:'?redirect=/pages/edenpure®-gen70-heater-b1g50',//112524
   W0961:'?redirect=/pages/edenpure-mist-free-humidifier',
   W0969:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',
   W0974:'?redirect=/products/edenpure®-classic-copperplus™-infrared-heater',
   W0978:'?redirect=/products/edenpure-total-relief-heating-pad',
   W0980:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',
   W0983:'?redirect=/pages/edenpure-360-climater',
   W0984:'?redirect=/pages/edenpure-mist-free-humidifier',
   W0987:'?redirect=/products/edenpure®-gen21-edenpure-all-season-heater®',
   W0989:'?redirect=/pages/edenpure-bio-speedclean-vx300',
   W0990:'?redirect=/pages/edenpure®-gen70-heater',
   W0991:'?redirect=/pages/edenpure-g9-air-purifier',
   W0992:'?redirect=/pages/edenpure-all-season-heater-sales',
   W0992X:'?redirect=/pages/edenpure-all-season-heater-sales',
   W0997:'?redirect=/products/edenpure®-thunderstorm®-oxileaf®-iii-air-purifier-bogo',//040125
   W0998:'?redirect=/pages/ep-gen40-hybrid-infrared-heater',//040125
   W0999:'?redirect=/pages/oxileaf-air-purifier-bogo-special',
   W1000:'?redirect=/pages/edenpure-360-climater',
   W1003:'?redirect=/pages/edenpure-totalrelief-heating-pads-sale',//040125
   W1006:'?redirect=/pages/edenpure-copperplus-heater-eos',//040825
   W1010:'?redirect=/pages/uscg-250th-anniversary-declaration-art-print',//040925
   W1011:'?redirect=/pages/uscg-250th-anniversary-declaration-plaque',//040925
   W1013:'?redirect=/pages/oxileaf-iii-thunderstorm-air-purifier-rr',//041425
   W1014:'?redirect=/pages/oxileaf-iii-thunderstorm-air-purifier-rr',//041625
   W1015:'?redirect=/pages/oxileaf-iii-thunderstorm-air-purifier-rr',//041625
   W1018:'?redirect=/pages/oxileaf-iii-thunderstorm-air-purifier-rr',//041625
   W1019:'?redirect=/pages/ep-360-air-fan',//042825
   W1020:'?redirect=/pages/oxileaf®-iii-thunderstorm®-air-purifier-bogo',//050225
   W1021:'?redirect=/pages/oxileaf®-iii-thunderstorm®-air-purifier-bogo',//050225
   W1022:'?redirect=/pages/edenpure®-gen40-hybrid-infrared-heater-email',//050225
   W1023:'?redirect=/pages/edenpure®-gen40-hybrid-infrared-heater-email',//050225
   XLF119:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//040424 
   XLF120:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//040424 
   XLF121:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//041624
   XLF122:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//041624
   XLF123:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//041624
   XLF124:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//041624
   XLF125:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//041624
   XLF126:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//041624
   XLF127:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//041624
   XLF128:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//041624
   XLF129:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//041624
   XLF130:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//041624
   XLF131:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//041624
   XLF132:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//072924
   XLF133:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//072924
   XLF134:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//072924
   XLF135:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//072924
   XLF136:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//072924
   XLF137:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//072924
   XLF138:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//072924
   XLF139:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//072924
   XLF140:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//072924
   XLF141:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//072924
   XLF142:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//072924
   XLF143:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//072924
   XLF144:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//072924
   XLF145:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//072924
   XLF146:'?redirect=/products/edenpure-thunderstorm-oxileaf-ii-air-purifier-web-offer',//072924
   XLF147:'?redirect=/products/edenpure-thunderstorm-oxileaf-iii-air-purifier-web-radio-offer',//111224
   XLF148:'?redirect=/products/edenpure-thunderstorm-oxileaf-iii-air-purifier-web-radio-offer',//111224
   XLF149:'?redirect=/products/edenpure-thunderstorm-oxileaf-iii-air-purifier-web-radio-offer',//111224
   XLF150:'?redirect=/products/edenpure-thunderstorm-oxileaf-iii-air-purifier-web-radio-offer',//111224
   XLF151:'?redirect=/products/edenpure-thunderstorm-oxileaf-iii-air-purifier-web-radio-offer',//111224
   XLF152:'?redirect=/products/edenpure-thunderstorm-oxileaf-iii-air-purifier-web-radio-offer',//111224
   XLF153:'?redirect=/products/edenpure-thunderstorm-oxileaf-iii-air-purifier-web-radio-offer',//111224
   XLF154:'?redirect=/products/edenpure-thunderstorm-oxileaf-iii-air-purifier-web-radio-offer',//111224
   XLF154A:'?redirect=/products/edenpure-thunderstorm-oxileaf-iii-air-purifier-web-radio-offer',//111224
   XLF154B:'?redirect=/products/edenpure-thunderstorm-oxileaf-iii-air-purifier-web-radio-offer',//111224
   XLF154C:'?redirect=/products/edenpure-thunderstorm-oxileaf-iii-air-purifier-web-radio-offer',//111224
   XLF154D:'?redirect=/products/edenpure-thunderstorm-oxileaf-iii-air-purifier-web-radio-offer',//111224
   XLF155A:'?redirect=/products/edenpure-thunderstorm-oxileaf-iii-air-purifier-web-radio-offer',//111224
   XLF155B:'?redirect=/products/edenpure-thunderstorm-oxileaf-iii-air-purifier-web-radio-offer',//111224

       ANSWER3:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       BACK3PACK:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       BECK:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       BECKBOGO:'?redirect=/pages/radio-oxileaf-iii-bogo-deal',
       CHAT3:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       CHATBOGO:'?redirect=/pages/radio-oxileaf-iii-bogo-deal',
       CHICKS3:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       CHICKSBOGO:'?redirect=/pages/radio-oxileaf-iii-bogo-deal',
       CHRIS3:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       CHRIS50:'?redirect=/products/edenpure®-gen40-infrared-heater',
       CHRISBOGO:'?redirect=/pages/radio-oxileaf-iii-bogo-deal',
       CLYDEDEAL:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       ERIC3:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       ERICK3:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       ERICK360:'?redirect=/products/edenpure-360-air-fan-heater-cooler',
       ERICK50:'?redirect=/products/edenpure®-gen40-infrared-heater-2',
       ERIC50:'?redirect=/products/edenpure®-gen40-infrared-heater-2',
       ERICKBOGO:'?redirect=/pages/radio-oxileaf-iii-bogo-deal',
       ERICBOGO:'?redirect=/pages/radio-oxileaf-iii-bogo-deal',
       GLENN3:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       GODZILLA2:'?redirect=/pages/radio-oxileaf-iii-2-pack',
       GODZILLA50:'?redirect=/products/edenpure®-gen40-infrared-heater-2',
       GODZILLABOGO:'?redirect=/pages/radio-oxileaf-iii-bogo-deal',
       GRACE3:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       GRACE50:'?redirect=/products/edenpure-total-relief-heating-pad',
       GRACE360:'?redirect=/products/edenpure-360-air-fan-heater-cooler',
       GRACEBOGO:'?redirect=/pages/radio-oxileaf-iii-bogo-deal',
       HOWIE3:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       HOWIE30:'?redirect=/products/edenpure-360-air-fan-gen55',
       HOWIE50:'?redirect=/products/edenpure®-gen40-infrared-heater-2',
       HOWIE360:'?redirect=/products/edenpure-360-air-fan-heater-cooler',
       HOWIEBOGO:'?redirect=/pages/radio-oxileaf-iii-bogo-deal',
       JEFF3:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       JEFFBOGO:'?redirect=/pages/radio-oxileaf-iii-bogo-deal',
       JEREMY3:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       MARK3:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       MICHELLE3:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       PAGS3:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       PAGS50:'?redirect=/products/edenpure®-gen40-infrared-heater',
       PAGSBOGO:'?redirect=/pages/radio-oxileaf-iii-bogo-deal',
       PAT3:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       PATBOGO:'?redirect=/pages/radio-oxileaf-iii-bogo-deal',
       RADIOBOGO:'?redirect=/pages/radio-oxileaf-iii-bogo-deal',
       RADIO100:'?redirect=/pages/edenpure-smart-painnot-appliances',
       REDEYE3:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       REDEYE50:'?redirect=/products/edenpure®-gen40-infrared-heater',
       REDEYEBOGO:'?redirect=/pages/radio-oxileaf-iii-bogo-deal',
       RUMBLE3:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       SPOT3:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       STEVE3:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       STEVEBOGO:'?redirect=/pages/radio-oxileaf-iii-bogo-deal',
       TODD3:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       TODDBOGO:'?redirect=/pages/radio-oxileaf-iii-bogo-deal',
       TOTH3:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       UNX2:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       VARA3:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       WJ3:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       WJ50:'?redirect=/products/edenpure®-gen40-infrared-heater',
       WJBOGO:'?redirect=/pages/radio-oxileaf-iii-bogo-deal',
       WJDEAL:'?redirect=/pages/radio-oxileaf-iii-3-pack',
       TESTBOGO:'?redirect=/products/copy-of-edenpure®-oxileaf®-ii-thunderstorm-air-purifier'

      //

    };

    var radiored2 = {
       CHRIS3:'D0310',
       CHRIS50:'D0310',
       CHRISBOGO:'D0310',
       ERICK3:'D0308',
       ERICK50:'D0308',
       ERIC50:'D0308',
       ERICBOGO:'D0308',
       ERICKBOGO:'D0308',
       GLENN3:'D0312',
       GODZILLA2:'D0307',
       GODZILLA50:'D0307',
       GODZILLABOGO:'D0307',
       GRACE3:'D0306',
       GRACE50:'D0306',
       GRACEBOGO:'D0306',
       HOWIE3:'D0305',
       HOWIE50:'D0305',
       HOWIEBOGO:'D0305',
       PAGS3:'D0309',
       PAGS50:'D0309',
       PAGSBOGO:'D0309',
       PAT3:'D0313',
       PATBOGO:'D0313',
       REDEYE3:'D0311',
       REDEYE50:'D0311',
       REDEYEBOGO:'D0311',
       WJ3:'D0314',
       WJ50:'D0314',
       WJBOGO:'D0314',
    AP72:'AP72',
   BAF13A:'BAF13A',
   BAF13B:'BAF13B',
   BAF15:'BAF15',
   BAF16:'BAF16',
   BCV21:'BCV21',
   BCV22:'BCV22',
   BCV23:'BCV23',
   BCV24:'BCV24',
   BCV26:'BCV26',
   BCV27:'BCV27',
   BCV28:'BCV28',
   BCV29:'BCV29',
    DAF18:'DAF18',
    DAF19:'DAF19',
    EH587:'EH587',
    EH590:'EH590',
    EH590A:'EH590A',
    EH590B:'EH590B',
    EH591:'EH591',
    EH592:'EH592',
    EH593:'EH593',
    EH594:'EH594',
      EH595:'EH595',
EH596:'EH596',
EH597:'EH597',
EH598:'EH598',
EH599:'EH599',
EH600:'EH600',
EH601:'EH601',
EH602:'EH602',
EH603:'EH603',
EH604:'EH604',
EH607:'EH607',
EH608:'EH608',
EH609:'EH609',
EH610:'EH610',
EH613:'EH613',
EH614:'EH614',
EH615:'EH615',
EH616:'EH616',
EH617:'EH617',
EH618:'EH618',
EH619:'EH619',
EH619A:'EH619A',
EH619B:'EH619B',
EH619C:'EH619C',
EH620:'EH620',
EH621:'EH621',
EH622:'EH622',
EH623:'EH623',
EH624:'EH624',
EH625:'EH625',
EH626:'EH626',
EH628:'EH628',
EH629:'EH629',
EH630:'EH630',
EH631:'EH631',
EH632A:'EH632A',
EH632B:'EH632B',
EH632C:'EH632C',
EH632D:'EH632D',
EH633:'EH633',
EH634:'EH634',
EH635:'EH635',
EH636:'EH636',
EH637:'EH637',
EH638:'EH638',
EH639:'EH639',
EH640:'EH640',
EH641:'EH641',
EH642:'EH642',
EH643:'EH643',
EH644:'EH644',
EH645:'EH645',
EH646:'EH646',
EH647:'EH647',
EH648:'EH648',
EH649:'EH649',
EH650:'EH650',
EH653A:'EH653A',
EH653B:'EH653B',
    EHB10:'EHB10',
    EPSC20:'EPSC20',
    EPSC21:'EPSC21',
    EPSC22:'EPSC22',
    FM2VS:'W0667',
    GAP10:'GAP15', 
    GAP11:'GAP11', 
    GAP12:'GAP12', 
    GAP13:'GAP13', 
    GAP14:'GAP14', 
    GAP15:'GAP15', 
    GAP16:'GAP16', 
    G40FT14:'G40FT14', 
    G40FT24:'G40FT24', 
    G40FN43:'G40FN43', 
    G40FN14:'G40FN14', 
    G40FN24:'G40FN24',
    G40PF14:'G40PF14',
    G40PF24:'G40PF24',
    G40PF34:'G40PF34',
    G40PF44:'G40PF44',
    HMD11:'HMD11',
    HMD12:'HMD12',
    HMD13:'HMD13',
    HMD14:'HMD14',
    HMD15:'HMD15',
    STOCKNOW:'EC2EP15',
    SLVI:'SLVI15',
    THUNDER3:'W0679',
    THUNDER20:'THUNDER20',
    THUNDER21:'THUNDER21',
    THUNDER22:'EPTV27',
    TJW4H:'W0688',
    TRP11:'TRP11',
    TRP12:'TRP12',
    TV$50:'EC2EP15',
    TVS50:'EC2EP15',
    TV1212:'W0949',
    TV1313:'W0975',
    TV2323:'EC2EP15',
    TV2525:'EC2EP15',
    TV3838:'EC2EP15',
    TV4242:'EC2EP15',
    TV4545:'EC2EP15',
    TV5353:'EC2EP15',
    TV5656:'EC2EP15',
    TV6565:'EC2EP15',
    TV6767:'W0948',
    TV7878:'W0946',
    TV8989:'W0947',
    TV9090:'W0975',
    TVBOGO:'EC2EP15',
    SPOT3:'SPOT3',
W0861:'W0861',
W0862:'W0862',
W0863:'W0863',
W0864:'W0864',
W0865:'W0865',
W0866:'W0866',
W0867:'W0867',
W0868:'W0868',
W0869:'W0869',
W0870:'W0870',
W0871:'W0871',
W0872:'W0872',
W0873:'W0873',
W0874:'W0874',
W0875:'W0875',
W0876:'W0876',
W0877:'W0877',
W0878:'W0878',
W0879:'W0879',
W0880:'W0880',
W0881:'W0881',
W0882:'W0882',
W0883:'W0883',
W0884:'W0884',
W0885:'W0885',
W0886:'W0886',
W0887:'W0887',
W0888:'W0888',
W0889:'W0889',
W0890:'W0890',
W0891:'W0891',
W0892:'W0892',
W0893:'W0893',
W0894:'W0894',
W0895:'W0895',
W0896:'W0896',
W0897:'W0897',
W0898:'W0898',
W0899:'W0899',
W0900:'W0900',
W0903:'W0903',
W0905:'W0905',
W0906:'W0906',
W0907:'W0907',
W0908:'W0908',
AD909:'W0909',
W0910:'W0910',
W0911:'W0911',
W0912:'W0912',
W0913:'W0913',
W0914:'W0914',
W0915:'W0915',
W0916:'W0916',
W0917:'W0917',
W0918:'W0918',
W0919:'W0919',
W0920:'W0920',
W0921:'W0921',
W0922:'W0922',
W0923:'W0923',
W0924:'W0924',
W0925:'W0925',
W0926:'W0926',
W0927:'W0927',
W0928:'W0928',
W0929:'W0929',
W0930:'W0930',
W0931:'W0931',
W0932:'W0932',
W0933:'W0933',
W0934:'W0934',
W0935:'W0935',
W0936:'W0936',
W0937:'W0937',
W0938:'W0938',
W0939:'W0939',
W0940:'W0940',
W0944:'W0944',
W0945:'EC2EP25',
W0950:'W0950',
W0951:'W0951',
W0952:'W0952',
W0953:'W0953',
W0954:'W0954',
W0955:'W0955',
W0956:'W0956',
W0957:'W0957',
W0958:'W0958',
W0959:'W0959',
W0960:'EC2EP15',
W0961:'W0961',
W0970:'W0970',
W0974:'W0974',
W0978:'W0978',
W0980:'W0980',
W0983:'W0983',
W0984:'W0984',
W0987:'W0987',
W0991:'W0991',
W0992:'W0992',
W0992X:'W0992',
W0999:'W0999',
W1000:'W1000',
W1003:'W1003',
W1006:'W1006',
W1010:'EPCLC25',
W1011:'EPCLC25',
W1013:'W1013',
W1014:'W1014',
W1015:'W1015',
W1019:'W1019',
W1020:'W1020',
W1021:'W1021',
W1022:'W1022',
W1023:'W1023',
    XLF121:'XLF121',
    XLF122:'XLF122',
    XLF123:'XLF123',
    XLF124:'XLF124',
    XLF125:'XLF125',
    XLF126:'XLF126',
    XLF127:'XLF127',
    XLF128:'XLF128',
    XLF129:'XLF129',
    XLF130:'XLF130',
    XLF131:'XLF131',
    XLF132:'XLF132',
    XLF133:'XLF133',
    XLF134:'XLF134',
    XLF135:'XLF135',
    XLF136:'XLF136',
    XLF137:'XLF137',
    XLF138:'XLF138',
    XLF139:'XLF139',
    XLF140:'XLF140',
    XLF141:'XLF141',
    XLF142:'XLF142',
    XLF143:'XLF143',
    XLF144:'XLF144',
    XLF145:'XLF145',
    XLF146:'XLF146',
    XLF147:'XLF147',
    XLF148:'XLF148',
    XLF149:'XLF149',
    XLF150:'XLF150',
    XLF151:'XLF151',
    XLF152:'XLF152',
    XLF154:'XLF154',
    XLF154A:'XLF154A',
    XLF154B:'XLF154B',
    XLF154C:'XLF154C',
    XLF154D:'XLF154D',
    TEST:'HELLO',
    XLW11:'XLW11',
    XLW12:'XLW12',
    XLW13:'XLW13'
    
    };
    